import { render, staticRenderFns } from "./OrderPrinter.vue?vue&type=template&id=6e524a99&scoped=true&"
import script from "./OrderPrinter.vue?vue&type=script&lang=js&"
export * from "./OrderPrinter.vue?vue&type=script&lang=js&"
import style0 from "./OrderPrinter.vue?vue&type=style&index=0&id=6e524a99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e524a99",
  null
  
)

export default component.exports